import { addDays, dateIsBefore } from 'lib/datetime/dateUtils'

export default function verifyItemFollowsRegionalRules(countryCode?: string, earliestCheckingDate?: Date) {
  if (!countryCode || !earliestCheckingDate) return false

  // Maldives
  if (countryCode === 'MV') return false

  if (
    // Indonesia or Fiji
    (countryCode === 'ID' || countryCode === 'FJ')
  ) {
    const thirtyDaysFromNow = addDays(new Date(), 30)
    if (dateIsBefore(earliestCheckingDate, thirtyDaysFromNow)) {
      return false
    }
  }

  return true
}
